import { Metadata_Population, PopulationType_General } from '../population/index.js';
import { EpidemiologyRate_Percentage, EpidemiologyRate_Ratio, EpidemiologyRates, EpidemiologyType_Prevalence, EpidemiologyTypes } from './types.js';
import { ImplementationMissingException } from '@nu-art/ts-common';
export const EpidemiologyTypeLabelMap = {
    incidence: 'Incidence',
    prevalence: 'Prevalence',
};
export const EpidemiologyRateLabelMap = {
    ratio: 'Ratio',
    percentage: 'Percentage',
};
export const initialEpidemiology = Object.freeze({
    type: EpidemiologyType_Prevalence,
    data: {
        rate: EpidemiologyRate_Percentage,
        rateValue: [0, 0]
    },
    population: {
        type: PopulationType_General,
    }
});
const translateRateValue = (old) => {
    if (old.rate === EpidemiologyRate_Percentage)
        return old.rateValue;
    if (old.rate === EpidemiologyRate_Ratio)
        return {
            numerator: [old.rateValue[0], old.rateValue[0]],
            denominator: old.rateValue[1],
        };
    throw new ImplementationMissingException(`Missing implementation for epidemiology of rate ${old.rate}`);
};
export const epidemiologyOldConverter = (old) => {
    return {
        type: old.type,
        population: old.population,
        // @ts-ignore
        data: {
            rate: old.rate,
            rateValue: translateRateValue(old)
        }
    };
};
export const Metadata_Epidemiology = {
    type: {
        optional: false,
        description: `Type of the epidemiology (${[...EpidemiologyTypes].join(' / ')})`,
        valueType: 'string',
    },
    rate: {
        optional: false,
        description: `Rate display of the epidemiology (${[...EpidemiologyRates].join(' / ')})`,
        valueType: 'string',
    },
    rateValue: {
        optional: false,
        description: 'Rate value of the epidemiology',
        valueType: 'number[]',
        metadata: {
            optional: false,
            description: 'number value in the rate',
            valueType: 'number',
        }
    },
    population: { ...Metadata_Population },
    // TODO: fix this const by the type
};
//# sourceMappingURL=consts.js.map